<template>
  <CRow>
    <CCol xs="12" sm="12" md="12" lg="4" xl="3">
      <CCard>
        <CCardHeader class="d-flex justify-content-between">
          <b><i class="fas fa-calendar"></i>&nbsp;Fecha</b>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
              <CInput label="Desde" type="date" aria-label="shift_date" @input="validateDates" size="sm" id="init"
                v-model="filter_init" :max="today" />
            </CCol>
            <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
              <CInput label="Hasta" type="date" aria-label="shift_date" @input="validateDates" id="end" size="sm"
                v-model="filter_end" :max="today" />
            </CCol>
          </CRow>
        </CCardBody>
      </CCard>
    </CCol>
    <CCol xs="12" sm="12" md="12" lg="8" xl="9">
      <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed caption="Reporte"
        icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'" :actions="true" :myButtons="myButtons"
        @mtdAddDescription="mtdAddDescription">
      </CTableWrapper>
    </CCol>
    <CModalDescription :id_reserva="modalDescription.id_reserva" :title="modalDescription.title"
      :boo_modal="modalDescription.modal_form" :item="modalDescription.item"
      @closeModalDescription="closeModalDescription" @mtdAddDescription="mtdAddDescription" />
  </CRow>
  
</template>

<script>
const fields = [
  { key: "index", label: "Cita", _style: "width:5%;" },
  { key: "date_formatted", label: "Fecha de Cita", _style: "width:5%;" },
  { key: "barbers", label: "Encargados", _style: "width:5%;" },
  { key: "name_client", label: "Cliente", _style: "width:5%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";
import CModalDescription from "./modals/cModalDescription.vue";

//modal

export default {
  components: {
    CTableWrapper,
    CModalDescription,
  },
  data() {
    return {
      prefix: "report",
      fields,
      data: [],
      today: moment().format("YYYY-MM-DD"),
      filter: {
        init: null,
        end: null,
      },

      //buttons
      myButtons: [
        {
          class: "btn-sm",
          color: "success",
          tooltip: "Editar",
          action: "mtdAddDescription",
          icon: "fas fa-edit",
        },
      ],

      //MODAL
      modalDescription: {
        title: "AGREGAR DESCRIPCION",
        modal_form: false,
        item: {},
        id_reserva: 0,
      },
    }
  },
  created() {
    moment.locale("es");
    this.filter_init = this.today;
    this.filter_end = this.today;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    closeModalDescription(refresh) {
      this.modalDescription = {
        modal_form: false,
      };
      if (refresh) {
        this.mtd_data();
      }
    },
    validateDates() {
      // No permitir fechas futuras
      if (this.filter_init > this.today) {
        this.filter_init = this.today;
      }
      if (this.filter_end > this.today) {
        this.filter_end = this.today;
      }

      // Valido rangos incorrectos
      if (this.filter_end < this.filter_init) {
        this.filter_init = this.filter_end;
      }
      if (this.filter_init > this.filter_end) {
        this.filter_end = this.filter_init;
      }
      this.mtd_data();
    },
    mtd_data: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byUnregisteredServices",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter_init,
          end: this.filter_end,
          campu_id: this.$store.getters.get_campu.id,
          company_id: this.$store.getters.get_company.id,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            let index = 1;
            this.data = response.data.data;
            this.data.forEach((item) => {
              item.index = index++;
              item.date_formatted = moment(item.date).format("DD/MM/YYYY");
              item.barbers = item.barber_detail && item.barber_detail.length > 0 ?
                item.barber_detail.map(det => det.barber ? det.barber.name + " " + det.barber.last_name : 'Personal desconocido').join(", ") : 'No existe Personal';
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtdAddDescription: function (item) {
      this.modalDescription = {
        title: "AGREGAR DESCRIPCIÓN",
        id_reserva: item.id,
        modal_form: true,
        item: item,
      };
    },
  }
}
</script>